import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-99928fac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "new-cookie-notice"
}
const _hoisted_2 = { class: "new-cookie-notice__container" }
const _hoisted_3 = { class: "new-cookie-notice__text-container" }
const _hoisted_4 = { class: "new-cookie-notice__headline-container" }
const _hoisted_5 = { class: "new-cookie-notice__text" }

import { onMounted, onUnmounted, ref } from 'vue';
  import cookieList from '../../configs/cookie-list';
  import { ICookie } from '../common/interfaces/index.interface';
  import CookieHelper from '../helpers/cookie-helper';
  import DomEventHelper from '../helpers/dom-event-helper';
  import PreferencesSection from './subcomponents/PreferencesSection.vue';
  import PreferencesSectionFooter from './subcomponents/PreferencesSectionFooter.vue';
  import CustomHeadline from './subcomponents/CustomHeadline.vue';
  import FlowerLogo from './subcomponents/FlowerLogo.vue';
  import JobsCookieInfo from './subcomponents/JobsCookieInfo.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CookieNotice',
  setup(__props) {

  const acceptedCookies = ref<string[]>([]);
  const cookies = ref<ICookie[]>(JSON.parse(JSON.stringify(cookieList)));
  const showCookieNotice = ref(true);
  const showJobsCookieInfo = ref(false);

  function setAllOptionalCookies(): void {
    showJobsCookieInfo.value = false;

    const optionalCookies = cookies.value.filter(cookie => cookie.name !== `necessary`);
    if(optionalCookies.length > 0) {
      for(const object of optionalCookies) {
        for(const cookie of object.cookies) {
          DomEventHelper.fireCookieSetEvent({ name: cookie.internalIdentifier });
          acceptedCookies.value.push(cookie.internalIdentifier);
        }
      }
    }
  }

  function setSelectedOptionalCookies(): void {
    const optionalCookies = cookies.value.filter(cookie => cookie.name !== `necessary`);
    if(optionalCookies.length > 0) {
      for(const object of optionalCookies) {
        for(const cookie of object.cookies) {
          if(cookie.active) {
            if(cookie.internalIdentifier === `Prescreen`) {
              showJobsCookieInfo.value = false;
            }

            DomEventHelper.fireCookieSetEvent({ name: cookie.internalIdentifier });
            acceptedCookies.value.push(cookie.internalIdentifier);
          }
        }
      }
    }
  }

  function setNecessaryCookies(): void {
    const necessaryCookies = cookies.value.find(cookie => cookie.name === `necessary`);
    if(necessaryCookies) {
      for(const cookie of necessaryCookies.cookies) {
        if(cookie.internalIdentifier === `ccn-interacted`) {
          // no need to fire an event for a cookie the notice itself sets
        } else {
          DomEventHelper.fireCookieSetEvent({ name: cookie.internalIdentifier });
          acceptedCookies.value.push(cookie.internalIdentifier);
        }
      }
    }
  }

  function hideCookieNotice(): void {
    showCookieNotice.value = false;
    document.body.classList.remove(`ccn-overflow-hidden`);
  }

  function acceptAll(): void {
    setNecessaryCookies();
    setAllOptionalCookies();
    CookieHelper.setCcnInteracted(acceptedCookies.value);
    hideCookieNotice();
  }

  function acceptSelection(): void {
    setNecessaryCookies();
    setSelectedOptionalCookies();
    CookieHelper.setCcnInteracted(acceptedCookies.value);
    hideCookieNotice();
  }

  function checkFunctionalCookies(): void {
    showJobsCookieInfo.value = true;
  }

  function updateAllCookiesOfCategory(active: boolean, indexOfCategory: number): void {
    for(const cookie of cookies.value[indexOfCategory].cookies) {
      cookie.active = active;
    }
  }

  function updateCategory(category: string): void {
    const cookieTypeIndex = cookies.value.findIndex(cookie => cookie.name === category);
    if(cookieTypeIndex > -1) {
      const activeCookies = cookies.value[cookieTypeIndex].cookies.filter(cookie => cookie.active);
      if(activeCookies.length > 0) {
        if(activeCookies.length === cookies.value[cookieTypeIndex].cookies.length) {
          cookies.value[cookieTypeIndex].active = true;
          cookies.value[cookieTypeIndex].indeterminate = false;
        } else {
          cookies.value[cookieTypeIndex].active = false;
          cookies.value[cookieTypeIndex].indeterminate = true;
        }
      } else {
        cookies.value[cookieTypeIndex].active = false;
        cookies.value[cookieTypeIndex].indeterminate = false;
      }
    }
  }

  function updateCategoryActive(event: { active: boolean; cookies: ICookie }): void {
    const eventToModify = event;
    eventToModify.cookies.active = event.active;
    eventToModify.cookies.indeterminate = false;
    const cookieTypeIndex = cookies.value.findIndex(cookie => cookie.name === eventToModify.cookies.name);
    cookies.value.splice(cookieTypeIndex, 1, eventToModify.cookies);
    updateAllCookiesOfCategory(eventToModify.active, cookieTypeIndex);
  }

  function updateCookiesForJobs(): void {
    CookieHelper.removeNonEssentialCookies();
    showCookieNotice.value = true;
  }

  function updateSingleCookieActive(event: { active: boolean; cookieCategory: string; cookieName: string }): void {
    const cookieTypeIndex = cookies.value.findIndex(cookie => cookie.name === event.cookieCategory);
    const cookieObject = cookies.value[cookieTypeIndex].cookies.find(cookie => cookie.internalIdentifier === event.cookieName);
    const cookieObjectIndex = cookies.value[cookieTypeIndex].cookies.findIndex(cookie => cookie.internalIdentifier === event.cookieName);
    if(cookieObject && cookieObjectIndex > -1) {
      cookieObject.active = event.active;
      cookies.value[cookieTypeIndex].cookies.splice(cookieObjectIndex, 1, cookieObject);
    }
    updateCategory(event.cookieCategory);
  }

  onMounted(() => {
    if(CookieHelper.getCcnInteracted() && CookieHelper.checkVersion()) {
      hideCookieNotice();
    } else {
      document.body.classList.add(`ccn-overflow-hidden`);
    }

    document.addEventListener(`rin-cookie-settings-info`, checkFunctionalCookies);
  });

  onUnmounted(() => {
    document.removeEventListener(`rin-cookie-settings-info`, checkFunctionalCookies);
  });

return (_ctx: any,_cache: any) => {
  return (showCookieNotice.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(FlowerLogo, { class: "new-cookie-notice__flower-logo" }),
              (_ctx.$t(`${_ctx.$translationsUfeNamespace}notice.headline`))
                ? (_openBlock(), _createBlock(CustomHeadline, {
                    key: 0,
                    class: "new-cookie-notice__headline",
                    "icon-path": "icons/flower.svg",
                    text: _ctx.$t(`${_ctx.$translationsUfeNamespace}notice.headline`),
                    uppercase: ""
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.$translationsUfeNamespace}notice.text`)), 1)
          ]),
          _createVNode(PreferencesSection, {
            class: "new-cookie-notice__preferences",
            cookies: cookies.value,
            visible: "",
            "onUpdate:activeSingleCookie": updateSingleCookieActive,
            "onUpdate:categoryActive": updateCategoryActive
          }, null, 8, ["cookies"]),
          _createVNode(PreferencesSectionFooter, {
            class: "new-cookie-notice__footer",
            "onClick:ccnAcceptAll": acceptAll,
            "onClick:ccnAcceptSelection": acceptSelection
          })
        ])
      ]))
    : (showJobsCookieInfo.value && !showCookieNotice.value)
      ? (_openBlock(), _createBlock(JobsCookieInfo, {
          key: 1,
          "onUpdate:cookies": updateCookiesForJobs
        }))
      : _createCommentVNode("", true)
}
}

})